export const SET_ADMIN_ROLE = 'ADMIN_USER/SET_ADMIN_ROLE'
export const SET_ADMIN_ROLES = 'ADMIN_USER/SET_ADMIN_ROLES'
